import { DialogTitle as MUIDialogTitle } from '@mui/material';
import React from 'react';
import { Typography } from '../../../../electrons';
import { useStyles } from './DialogTitle.styles';
export function DialogTitle(props) {
    const classes = useStyles();
    return (React.createElement(MUIDialogTitle, { className: props.className, classes: { root: classes.root }, id: props.id, "data-testid": props.testid }, props.disableTypography ? (props.children) : (React.createElement(Typography, { variant: "h4", className: classes.typography, align: "center" }, props.children))));
}
//# sourceMappingURL=DialogTitle.js.map